import React, { useEffect } from "react";

import MasterLedgerTable from "./MasterLedgerTable";
import MasterLedgerAdd from "./MasterLedgerAdd";
import MasterLedgerEdit from "./MasterLedgerEdit";
import useApiNew from "../../../utils/useApiNew";
import axios from "axios";

import Breadcrumbs from "../../../components/ui/Breadcrumbs";
import DeleteAlert from "../../../components/ui/DeleteAlert";

import Notification, {
  errorNotify,
  successNotify,
} from "../../../Services/Notification";
import { actionPermissions } from "../../../components/authNavigation/AuthNavbar";

const ledgerApiURL = `${process.env.REACT_APP_API_URL}api/ledger`;
const exportIndustryApiURL = `${process.env.REACT_APP_API_URL}api/export-ledger`;

const MasterLedger = () => {
  const [renderKey, setRenderKey] = React.useState(0);
  const [isAdd, setIsAdd] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [selectedItemId, setSelectedItemId] = React.useState();
  const [globalFilters, setGlobalFilters] = React.useState();
  const [bankData, setBankData] = React.useState();
  const [isButtonClicked, setIsButtonClicked] = React.useState();
  const [isDownloadClicked, setIsDownloadClicked] = React.useState();

  const triggerRerender = () => {
    setRenderKey((prevKey) => prevKey + 1);
  };

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  let { data, loading } = useApiNew(
    ledgerApiURL,
    "GET",
    { headers },
    renderKey,
  );

  data = data?.map((item) => ({
    ...item,
    status: item.status ? "Active" : "Inactive",
    credit_debit: item.credit_debit === "C" ? "Credit" : "Debit",
    account_type:
      item.account_type === "L"
        ? "Liability"
        : item.account_type === "I"
        ? "Income"
        : item.account_type === "E"
        ? "Expense"
        : item.account_type === "A"
        ? "Asset"
        : "",
  }));

  const filterBankData = () => {
    let filterData = data;
    if (globalFilters) {
      filterData = data.filter(
        (item) =>
          item?.account_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.group_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.account_type
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.head_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.credit_debit
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.account_short_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.status?.toLowerCase() === globalFilters?.toLowerCase(),
      );
    }
    setBankData(filterData);
  };
  useEffect(() => {
    filterBankData();
  }, [globalFilters]);

  // ADD

  const handleAddIndustry = async (data) => {
    setIsButtonClicked(true);
    console.log(data);
    try {
      const res = await axios.post(ledgerApiURL, data, { headers });
      const resData = res.data;

      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // EDIT

  const handleEditIndustry = async (segmentId, data) => {
    setIsButtonClicked(true);
    const updateAPI = `${ledgerApiURL}/${segmentId}`;

    try {
      const res = await axios.put(updateAPI, data, { headers });
      const resData = res.data;
      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // DELETE

  const handleDeleteIndustry = async () => {
    const deleteAPI = `${ledgerApiURL}/${selectedItemId}`;
    try {
      const res = await axios.delete(deleteAPI, { headers });
      const resData = res.data;
      triggerRerender();
      if (!resData.error) {
        successNotify("Data deleted.");
        setIsDelete(false);
        return true;
      } else {
        errorNotify(resData?.message);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      return false;
    }
  };
  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10);

  const downloadExcel = async (filename) => {
    try {
      const apiEndpoint = exportIndustryApiURL;
      const headers = {
        Authorization: `Bearer ${
          sessionStorage.getItem("subscriberToken")
            ? sessionStorage.getItem("subscriberToken")
            : sessionStorage.getItem("token")
        }`,
      };
      const response = await axios.get(apiEndpoint, {
        headers,
        responseType: "blob",
      });

      if (response && response.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename; // Set the filename here

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        setIsDownloadClicked(false);
      } else {
        console.error("Invalid response or missing data");
        setIsDownloadClicked(false);
      }
    } catch (error) {
      errorNotify("Something went wrong.");
      setIsDownloadClicked(false);
    }
  };

  const downloadIndustry = () => {
    setIsDownloadClicked(true);
    const filename = `Ledger-Master_${formattedDate}.xlsx`;
    downloadExcel(filename);
  };
  const breadcrumbs = ["Home", "Master", "Ledger"];

  const buttonConfig = {
    value: "ledger",
    name: "Ledger",
    addHandler: handleAddIndustry,
    editHandler: handleEditIndustry,
    deleteHandler: handleDeleteIndustry,
    downloadHandler: downloadIndustry,
    closeAddModal: () => setIsAdd(false),
    closeEditModal: () => setIsEdit(false),
  };
  const name = "ledger";

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />
      <MasterLedgerTable
        tableData={globalFilters ? bankData : data}
        buttonConfig={buttonConfig}
        setIsAdd={setIsAdd}
        loading={loading}
        setIsEdit={setIsEdit}
        setIsDelete={setIsDelete}
        setSelectedItemId={setSelectedItemId}
        renderKey={renderKey}
        setGlobalFilters={setGlobalFilters}
        actionPermissions={actionPermissions("masters", "Ledger")}
        isDownloadClicked={isDownloadClicked}
      />
      {isAdd && (
        <MasterLedgerAdd
          tableData={data}
          buttonConfig={buttonConfig}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isEdit && (
        <MasterLedgerEdit
          tableData={data}
          buttonConfig={buttonConfig}
          selectedItemId={selectedItemId}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isDelete && (
        <DeleteAlert
          closeHandler={() => setIsDelete(false)}
          deleteHandler={buttonConfig.deleteHandler}
        />
      )}
    </div>
  );
};

export default MasterLedger;
